// ==========================================================
export default function initPromoBar() {
    // PROMO BAR
    // ==========================================================

    const promoBar = document.querySelector(".header-promo");
    const promoClose = document.querySelector(".header-promo__close");

    if (promoBar && promoClose) {
        promoClose.addEventListener("click", () => {
            promoBar.classList.add("is-hidden");
        });
    }
}
